module.exports = __webpack_public_path__ + "static/img/fa-brands-400.5c2d83d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.svg
// module id = jTDg
// module chunks = 0